import { Dropdown } from 'antd'
import Flex from 'components/Flex'
import FilterIcon from 'components/icons/FilterIcon'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const FilterFlex = styled(Flex)`
  width: 50%;
  position: relative;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  cursor: pointer;
  height: 50px;
  padding-left: 10px;
  border-left: ${props =>
    props?.borderLeft ? 'unset' : ` 1px solid ${COLORS.GREY_T_90}`};
  border-right: 1px solid ${COLORS.GREY_T_90};
`

export const FlexWrap = styled(Flex)`
  width: ${props => (props?.width ? props?.width : '63%')};
  position: relative;
  .ant-dropdown {
    min-width: ${props =>
      props.minWidth ? `${props.minWidth}!important` : 'auto'};
    ${props => props.DWidth && `width: ${props.DWidth} !important;`}
  }
`
let randomString = Math.random().toString(36).substring(2, 7)

const FilterDiv = ({
  overlayMenu,
  label = 'Filter',
  trigger = 'click',
  open = false,
  setOpen,
  width = '63%',
  DWidth,
  minWidth,
  filterPosition,
  id = randomString,
}) => {
  const handleDropDownOpen = e => {
    e.preventDefault()
    setOpen(false)
  }
  const visibleChange = (flag) => {
   if(flag){
    setOpen(flag)
   }
  }

  return (
    <FlexWrap
      width={width}
      minWidth={minWidth}
      id={randomString}
      DWidth={DWidth}
    >
      <StyledDropdown
        overlay={overlayMenu}
        trigger={[trigger]}
        open={open}
        onOpenChange={visibleChange}
        getPopupContainer={trigger => trigger.parentNode}
        destroyPopupOnHide= {true}
        placement="bottomRight"
        borderLeft={filterPosition === 'end'}
      >
        <FilterFlex centerVertically onClick={e => handleDropDownOpen(e)}>
          {filterPosition === 'end' ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                padding: '10px',
                right: '15px',
                borderLeft: '1px solid rgb(230, 231, 234)',
                height: '45px',
                paddingLeft: '20px',
                top: 0,
                bottom: 0,
              }}
            >
              <FilterIcon />
              <FilterText>{label}</FilterText>
              {/* <div style={{ paddingLeft: 20 }}>
                <ArrowDownIco />
              </div> */}
            </div>
          ) : (
            <>
              <FilterIcon />
              <FilterText>{label}</FilterText>
            </>
          )}
        </FilterFlex>
      </StyledDropdown>
    </FlexWrap>
  )
}

export default FilterDiv
